module.exports = __webpack_public_path__ + "img/image337.e350fa28.png";